<ng-container *transloco="let t; read: 'user'">
<div>
    <div class="flex justify-between border-b">
        <h1 class="text-[25px] font-bold">{{ t('dashboard.session.title') }}</h1>
    </div>

    <div mat-dialog-content>
        <div class="content flex justify-center">
            <p class="pt-5">{{ t('dashboard.session.message') }}</p>
        </div>
        <div class="flex justify-center pb-5">
            <drdp-btn color="blue" (click)="removeOtherSession()" mat-button mat-dialog-close>
                {{ t('dashboard.session.removeOther') }}
            </drdp-btn>
        </div>
    </div>
    <hr>
    <div mat-dialog-actions class="flex self-end">
        <drdp-btn color="cancel" (click)="logout()" mat-button mat-dialog-close>
            {{ t('dashboard.session.logout') }}
        </drdp-btn>
    </div>
</div>
</ng-container>

